// Shared constants + helpers for the Marketing Report module.
import axios from 'axios';
import { personColor, categoryColor } from '../constants/palette';
import { money } from '../utils/money';

export const PROJECTS = ['RMC', 'Everyday Catering', 'W Factory', 'W in the Sky', 'W Timber', 'W Nexus'];
export const CATERING_PROJECTS = ['RMC', 'Everyday Catering'];
export const isCateringProject = (project) => CATERING_PROJECTS.includes(project);
export const CHANNELS = ['FB', 'Website', 'INSTA'];
export const PLATFORMS = ['FB', 'Instagram', 'Website/SEO', 'Google', 'TikTok', 'Others'];

// Sales people differ per project. Both catering projects use the RMC lead team
// (Ginny / Zac / Junk); the W-projects use the JQ/Zen/Zac set from the enquiry sheet.
const DEFAULT_SALESMEN = ['JQ', 'Zen', 'Zac'];
export const SALESMEN_BY_PROJECT = {
  'RMC': ['Ginny', 'Zac', 'Junk'],
  'Everyday Catering': ['Ginny', 'Zac', 'Junk'],
  'W Factory': DEFAULT_SALESMEN,
  'W in the Sky': DEFAULT_SALESMEN,
  'W Timber': DEFAULT_SALESMEN,
  'W Nexus': DEFAULT_SALESMEN,
};
export const salesmenFor = (project) => SALESMEN_BY_PROJECT[project] || DEFAULT_SALESMEN;

// "Ads" = the product/theme that generated the lead (RMC lead form). Free text.

// Fixed colour per project (used for dots, tabs, bars). Drawn from the
// shared categorical ramp (constants/palette.js) so project colour stays
// consistent with every other chart/legend in the app.
export const PROJECT_COLOR = Object.fromEntries(
  PROJECTS.map((project, i) => [project, categoryColor(project, i)])
);

export const CHANNEL_CLASS = { FB: 'fb', Website: 'web', INSTA: 'insta' };

// Fixed colour per salesperson (used in the daily-by-salesperson table).
// Backed by the shared person-identity palette so a name resolves to the
// same colour everywhere in the app, not just here.
export const SALESMAN_COLOR = { Ginny: personColor('Ginny'), JQ: personColor('JQ'), Zac: personColor('Zac'), Zen: personColor('Zen'), Junk: personColor('Junk') };
export const salesmanColor = (name) => personColor(name);

export const rm = (n) => money(Number(n) || 0);

export const rmShort = (n) => {
  const v = Number(n) || 0;
  if (v >= 1000) return 'RM ' + (v / 1000).toLocaleString('en-MY', { maximumFractionDigits: 1 }) + 'k';
  return rm(v);
};

// Display an ISO date (YYYY-MM-DD) as DD/MM without timezone drift.
export const fmtDM = (iso) => {
  if (!iso) return '';
  const [, m, d] = iso.split('-');
  return `${d}/${m}`;
};

export const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

export const api = axios.create({ baseURL: '/api/marketing' });
